import { render, staticRenderFns } from "./DataDic.vue?vue&type=template&id=65ea5ec0&scoped=true"
import script from "./DataDic.vue?vue&type=script&lang=js"
export * from "./DataDic.vue?vue&type=script&lang=js"
import style0 from "./DataDic.vue?vue&type=style&index=0&id=65ea5ec0&prod&lang=css"
import style1 from "./DataDic.vue?vue&type=style&index=1&id=65ea5ec0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65ea5ec0",
  null
  
)

export default component.exports